import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type ExportAnalyticsModalStore } from 'pages/analytics/ui/ExportAnalyticsModal/store/exportAnalyticsModalStore'

type IExportAnalyticsModalActionsProps = {
  store: ExportAnalyticsModalStore
}

export const ExportAnalyticsModalActions: FC<IExportAnalyticsModalActionsProps> = observer(
  ({ store: { onExport, disabled, loadingExport } }) => {
    return (
      <Button
        typeBtn={'contained'}
        text={'Export'}
        onClick={onExport}
        disabled={disabled}
        loading={loadingExport}
      />
    )
  }
)
